import _ from 'underscore';
import $ from 'jquery';
import ContentGridView from '../views/ContentGridView';
import ProductThumbnailView from '../views/ContentProductThumbnailView';
import Grid from './Grid';

export default class ContentGrid extends Grid {
  getContentTargetUrl() {
    const contentId = encodeURIComponent(this.content.contentId);
    const zone = encodeURIComponent(this.config.zone);
    const choiceId = encodeURIComponent(((this.config.encodedChoiceId.split('-'))[0] || '').replace(/^cid/, ''));
    let targetPath = '/shop/featured/';
    _.each(this.thumbnailCollection.models, (product, index) => {
      targetPath += ((index === 0) ? '' : ',') + product.get('id');
    });
    targetPath += `?prosSource=col&prosContent=${contentId}&prosZone=${zone}&prosChoiceId=${choiceId}`;
    this.content.contentTargetUrl = targetPath;
  }

  loadCollection(json) {
    this.content = json.content;
    this.recommendedIdsList = json.recommendedIdsList;
    this.thumbnailCollection = this.thumbnailCollectionClass.fromArray(
      json.recommendedIdsList,
      Object.assign({
        model: this.thumbnailModel,
        content: json.content,
        imageWidth: 400,
        arrowIconSize: this.config.arrowIconSize,
      }, this.config.customCarouselOptions),
      this.properties,
    );
  }
  createPanel({ items }) {
    const model = this.getPanelData(items);

    // Set Title href
    this.getContentTargetUrl();
    model.set('content', this.content);

    $(this.config.element).addClass('pros-factory-grid pros-content-grid');
    this.panel = new ContentGridView({
      el: this.config.element,
      model,
      childView: ProductThumbnailView.extend({
        tagName: 'li',
      }),
      config: this.config,
    });
  }

  dispatchPixelEvent({ pageIdsPos, currentPage, config }) {
    const that = this;
    const scrollListener = (view) => {
      const windowTop = $(window).scrollTop() + $(window).height();
      const prosPanelTop = view.$el.offset().top;
      if (windowTop > prosPanelTop) {
        // console.log('passed', windowTop, prosPanelTop);
        view.prosEventHandler.sendPixelEvent({
          pageIdsPos, currentPage, config, content: view.content,
        });
        view.pixelEventDispatched = true;
      }
    };

    if (this.properties.pixelPresentedEnabled) {
      scrollListener(this);

      if (!this.pixelEventDispatched) {
        $(window).scroll(() => {
          scrollListener(that);
        });
      }
    }
  }

  preprocessThumbs(thumbs) {
    if (thumbs.length < this.config.pageSize) {
      thumbs.splice(this.minimumProductsToDisplay);
    }
    return thumbs;
  }

  onRender(thumbs) {
    super.onRender(thumbs);
    if (thumbs.length > this.config.minimumProductsToDisplay) {
      $(this.config.element).find('ul').addClass('flex-grid');
      $(this.config.element).find('.contentThumb').addClass('flex-grid');
    }
  }
}
